export default __webpack_public_path__ + "static/media/Wallpaper-4.786e9261.jpg";